export const TOKEN_ADDRESS = '0x2d3a62162fa581f4d972b31fcc28ac9b2df3191b';

export const TOKEN_ABI = [
  // Only including the functions we need
  {
    "constant": true,
    "inputs": [{"name": "_owner", "type": "address"}],
    "name": "balanceOf",
    "outputs": [{"name": "balance", "type": "uint256"}],
    "type": "function"
  },
  {
    "constant": true,
    "inputs": [],
    "name": "decimals",
    "outputs": [{"name": "", "type": "uint8"}],
    "type": "function"
  },
  {
    "constant": true,
    "inputs": [],
    "name": "totalSupply",
    "outputs": [{"name": "", "type": "uint256"}],
    "type": "function"
  },
  {
    "constant": false,
    "inputs": [{"name": "_amount", "type": "uint256"}],
    "name": "consume",
    "outputs": [{"name": "success", "type": "bool"}],
    "type": "function"
  },
  {
    "constant": false,
    "inputs": [{"name": "minTokens", "type": "uint256"}],
    "name": "buyTokens",
    "outputs": [{"name": "success", "type": "bool"}],
    "payable": true,
    "stateMutability": "payable",
    "type": "function"
  },
  {
    "constant": true,
    "inputs": [],
    "name": "getTokenPrice",
    "outputs": [{"name": "price", "type": "uint256"}],
    "type": "function"
  }
]; 